import './inbox_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.ReviewCommentView extends Monitoring.Views.SocialContents.InboxContentView

  render: ->
    super
    reviewStarsView = new Monitoring.Views.ReviewStarsView()
    @$el.find('#comment-review-stars').html(reviewStarsView.render().el)
    reviewStarsView.setRating(@_starRating()) if @_starRating()
    this

  _starRating: ->
    if (@model.get('data').comment.starRating)  #todo remove that
      @model.get('data').comment.starRating
    else
      @model.get('data').userComment.starRating

  getHeaderView: (options) ->
    new Monitoring.Views.SocialContents.SocialContentReviewCommentHeaderView(options)
